import { PrimeIcons } from "primeng/api"

import { LgkNavMenuItem } from "@logick/ui/api"

export const CRM_MENU: LgkNavMenuItem = {
    label: "CRM",
    icon: PrimeIcons.ID_CARD,
    routerLink: "crm",
    items: [

        {
            label: "Contacts",
            routerLink: "contacts",
            featureState: { isLocked: false },
            routing: { loadComponent: () => import("@/features/crm/contacts/contact-list/contact-list").then((it) => it.CrmContactList) }
        },

        {
            label: "Campagnes",
            routerLink: "campaigns",
            featureState: { isLocked: true }
        },
        
    ]
}